import * as ng from 'angular';
import { PanelHeaderData } from '../../../atomic-components/molecules/panels/panel-header/panel-header';
import { UiRights } from '../../../configuration';
import { AuthContextService } from '../../../services';

export class TemplateBundleCancelDeleteController {
    public static $inject: string[] = ['$translate', 'authContext'];

    public modifier = '';
    public pageHeaderData: PanelHeaderData;

    public bundle;

    public userPanelRight;

    public faqArticleIdList: string[] = [
        'webspace-backup-create',
        'webspace-backup-restore'
    ];

    constructor(
        private $translate: ng.translate.ITranslateService,
        private authContext: AuthContextService
    ) {}

    public $onInit = () => {
        this.pageHeaderData = {
            backwardLink: 'bundle.id.dashboard',
            backwardText: this.$translate.instant('TR_090119-a32485_TR'),
            panelHeaderRoute: '',
            panelHeaderRouteParams: {},
            panelIcon: 'box-alt',
            panelTitle: this.$translate.instant('GENERAL.ACTION.TERMINATE-CANCEL')
        };

        this.userPanelRight = {
            cancelDeletion: {
                cancelDelete: this.authContext.isGranted(UiRights.BIL_BUNDLE_DELETE),
                editPanelButton: this.authContext.isGranted(UiRights.BIL_BUNDLE_DELETE)
            }
        };
    };
}

export class TemplateBundleCancelDeleteComponent implements ng.IComponentOptions {
    public bindings = {
        bundle: '<'
    };
    public controller = TemplateBundleCancelDeleteController;
    public controllerAs = '$TemplateBundleCancelDeleteCtrl';
    public template = require('./bundle-cancel-delete-template.html');
}
